import React from 'react';
import { Button, Box } from '@material-ui/core';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
// import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { confirmAdmissionColumn2 } from '../../ApprovalManagement/ConfirmAdmissionScreen/columns';
import { DEMO_PENDING_TABLE2 } from '../../ApprovalManagement/ConfirmAdmissionScreen/constant';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '50ch',
    },
  },
}));

function ManagementAppUser() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [state, setState] = React.useState({
    managementapp: false,
    discoveryapp: false,
    lft: false,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const { managementapp, discoveryapp, lft } = state;
  // const error = [gilad, jason, antoine].filter((v) => v).length !== 2;
  return (
    <div>
      <Box sx={{ m: 2, textAlign: 'right' }}>
        <Button variant="contained" color="primary" onClick={handleOpen}>
          <AddIcon />
          Add User
        </Button>
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={open}>
          <div className={classes.paper}>
            <h2 id="transition-modal-title">Add User</h2>
            <form className={classes.root} noValidate autoComplete="off">
              <TextField id="standard-basic" label="Name" />
              <br />
              <TextField id="standard-basic" label="Email Id" />
              <br />
              <TextField id="standard-basic" label="Phone Number" />
              <br />
              <br />
              <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">Module Access</FormLabel>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={managementapp}
                        onChange={handleChange}
                        name="managementapp"
                      />
                    }
                    label="Management App"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={discoveryapp}
                        onChange={handleChange}
                        name="discoveryapp"
                      />
                    }
                    label="Discovery App"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={lft}
                        onChange={handleChange}
                        name="lft"
                      />
                    }
                    label="JFT"
                  />
                </FormGroup>
              </FormControl>
              <br />
              <Button variant="contained" color="primary" sx={{ width: 100 }}>
                Submit
              </Button>
            </form>
          </div>
        </Fade>
      </Modal>
      <BuzzTable
        columns={confirmAdmissionColumn2}
        data={DEMO_PENDING_TABLE2}
        // columns={pendingTableColumn}
        // data={pendingTableData}
      />
      <Box display="flex" justifyContent="center">
        <BuzzPagination
          // onClick={handlePendingPageChange}
          total={10}
          pageNo={1}
          defaultPage={1}
          perPage={4}
        />
      </Box>
    </div>
  );
}

export default ManagementAppUser;
